"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
require("../../src/modules/bkselector/web"); //板块选择器
var wconfig = require('../../config/web.js');
var utils_1 = __importDefault(require("../../src/modules/commonutil/utils"));
var bkcode = bkInfo.code;
function tophqtable() {
    $.ajax({
        url: wconfig.getWebPath('quoteurl') + 'api/qt/stock/get',
        type: 'GET',
        dataType: 'jsonp',
        jsonp: 'cb',
        data: {
            fltt: "2",
            invt: "2",
            secid: '90.' + bkInfo.code,
            fields: "f57,f58,f107,f43,f169,f170,f171,f47,f48,f60,f46,f44,f45,f168,f113,f114,f444,f445,f446,f447",
            ut: "b2884a393a59ad64002292a3e90d46a5"
        }
    }).then(function (json) {
        var data = json && json.data;
        if (data) {
            var tds = $(".hqtoptable td");
            tds.eq(0).html("<a href=\"//quote.eastmoney.com/unify/r/90." + bkInfo.code + "\" target=\"_blank\">" + data["f58"] + "\u677F\u5757</a>");
            var xgzl = '';
            if (bkInfo.typecode == "hy") {
                xgzl = "<a href=\"//stock.eastmoney.com/hangye/hy" + bkInfo.code.replace('BK0', '').replace('BK', '') + ".html\" target=\"_blank\" style=\"color:#FF0000\">\u884C\u4E1A\u4E13\u533A</a>";
            }
            xgzl += " <a href=\"//quote.eastmoney.com/unify/r/90." + bkInfo.code + "\" target=\"_blank\">\u884C\u60C5</a> <a href=\"//guba.eastmoney.com/list," + data["f57"] + ".html\" target=\"_blank\">\u80A1\u5427</a>";
            if (bkInfo.typecode == "hy") {
                xgzl += " <a href=\"/report/" + bkInfo.code.replace('BK0', '').replace('BK', '') + "yb.html\" target=\"_blank\">\u7814\u62A5</a>";
            }
            tds.eq(1).html(xgzl);
            tds.eq(2).html(fieldtools_1["default"].fieldfmt(data["f170"], { num: 2, fix: "%", showcolor: true }));
            tds.eq(3).html(fieldtools_1["default"].fieldfmt(data["f168"], { num: 2, fix: "%" }));
            tds.eq(4).html("<span class=\"red\">" + data["f113"] + "</span>");
            tds.eq(5).html("<span class=\"green\">" + data["f114"] + "</span>");
            tds.eq(6).html(fieldtools_1["default"].isEmpty(data["f446"]) ? '-' : "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(data["f446"]) + "\">" + data["f445"] + "</a>");
            tds.eq(7).html(fieldtools_1["default"].fieldfmt(data["f444"], { num: 2, fix: "%", showcolor: true }));
        }
    });
}
// 画图
function draw_jg_cgtj(columns) {
    if (columns === void 0) { columns = "COMPOSITION_QUANTITY"; }
    var tableTypeMap = {
        "COMPOSITION_QUANTITY": "持股家数(家)",
        "HOLD_MARKET_CAP": "持股市值(元)",
        "HOLD_SHARES": "持股数量(股)" //持股数量
    };
    var params_cgtj = {
        reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_NEW',
        columns: 'ALL',
        filter: "(BOARD_CODE=\"" + bkcode + "\")",
        source: "WEB",
        client: "WEB",
        sortTypes: -1,
        sortColumns: 'HOLD_DATE',
    };
    var chart = echarts.init(document.getElementById("bkqs_chart"));
    $.ajax({
        url: wconfig.getWebPath('datacenter') + 'api/data/v1/get',
        type: 'GET',
        dataType: 'jsonp',
        data: params_cgtj
    }).then(function (result) {
        var res = result.result.data;
        res = res.reverse();
        var xADate = [];
        var cgsz = [];
        var spj = [];
        res.forEach(function (item) {
            xADate.push(fieldtools_1["default"].dateformat(item.HOLD_DATE));
            spj.push(item.CLOSE_PRICE);
            switch (columns) {
                case "COMPOSITION_QUANTITY":
                    cgsz.push(item.COMPOSITION_QUANTITY);
                    break;
                case "HOLD_MARKET_CAP":
                    cgsz.push(item.HOLD_MARKET_CAP);
                    break;
                case "HOLD_SHARES":
                    cgsz.push(item.HOLD_SHARES);
                    break;
                default:
                    break;
            }
        });
        //定义y轴最大值、最小值
        var y_min = 0;
        var option = {
            grid: {
                bottom: 50,
                top: 30,
                left: 100,
                right: 50,
                show: true,
                borderWidth: 1,
                borderColor: "#ccc"
            },
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    var relVal = params[0].name; //x轴名称  
                    for (var i = 0, l = params.length; i < l; i++) {
                        if (params[i].seriesName == '持股家数(家)' && params[i].value) {
                            relVal += '<br/> ' + params[i].marker + params[i].seriesName + ' : ' + params[i].value;
                        }
                        else if (params[i].value) {
                            relVal += '<br/> ' + params[i].marker + params[i].seriesName + ' : ' + utils_1["default"].numFormat(params[i].value);
                        }
                    }
                    return relVal;
                }
            },
            xAxis: {
                type: 'category',
                data: xADate,
                // 轴线
                axisLine: {
                    show: false
                },
                // 轴刻度线
                axisTick: {
                    show: false
                }
            },
            yAxis: [
                {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    // 轴线
                    axisLine: {
                        show: false
                    },
                    // 轴刻度线
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function (value, index) {
                            return utils_1["default"].numFormat(value, 1);
                        }
                    }
                },
                {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            color: '#e6e6e6',
                            type: 'dotted'
                        }
                    },
                    min: y_min,
                    // 轴线
                    axisLine: {
                        show: false
                    },
                    // 轴刻度线
                    axisTick: {
                        show: false
                    }
                }
            ],
            series: [{
                    name: tableTypeMap[columns],
                    type: 'line',
                    color: "#004986",
                    lineStyle: {
                        width: 1
                    },
                    data: cgsz
                }, {
                    name: '收盘价(元)',
                    type: "line",
                    color: "#FF0101",
                    yAxisIndex: 1,
                    lineStyle: {
                        width: 1
                    },
                    data: spj
                }]
        };
        chart.clear();
        chart.setOption(option, true);
    });
}
// 加载板块持股明细
function load_jgcgTable() {
    //南向个股和其他个股的持股统计用不同的接口；但字段名一致的，就通用columns配置
    var opt = {
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                reportName: 'RPT_MUTUAL_BOARD_HOLDRANK_NEW',
                columns: 'ALL',
                filter: "(BOARD_CODE=\"" + bkcode + "\")",
                pageSize: 50,
                source: "WEB",
                client: "WEB",
            },
        },
        sortname: 'HOLD_DATE',
        pagination: true,
        columns: {
            MAXHOLD_NAME: {
                formatter: function (value, item, i, field) {
                    return '<a href="/stockdata/' + item.MAXHOLD_SECURITY_CODE + '.html">' + value + '</a>';
                }
            },
            HOLD_ORG_NAME: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    var url = "/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="ellipsis w258" href="' + url + '" title="' + item.HOLD_ORG_NAME + '">' + item.HOLD_ORG_NAME + '</a>'; //机构名称
                }
            },
            HOLD_DATE: {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].dateformat(value);
                }
            },
            xg: {
                formatter: function (value, item, i, field) {
                    return '<a href="/hsgtV2/StockHdDetail/' + item.MAXHOLD_SECURITY_CODE + '.html" class="red">详细</a> <a href="//guba.eastmoney.com/list,' + item.MAXHOLD_SECURITY_CODE + '.html">股吧</a>';
                }
            },
            xg_jgph: {
                formatter: function (value, item, i, field) {
                    var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                    var url = "/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                    return '<a class="red" href="' + url + '">详细</a>';
                }
            },
            CHANGE_RATE: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            HOLD_SHARES: {
                formatter: { num: 2 }
            },
            HOLD_SHARES_LAST: {
                formatter: { num: 2 }
            },
            HOLD_SHARES_RATIO: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            COMPOSITION_QUANTITY_RATIO: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            HOLD_MARKET_CAP: {
                formatter: { num: 2 }
            },
            HOLD_MARKET_CAP_LAST: {
                formatter: { num: 2 }
            },
            ADD_SHARES_AMP: {
                formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
            },
            MAXHOLD_CAP: {
                formatter: { num: 2 }
            }
        },
        formatter: { strfmt: true },
    };
    $("#dataview_bkcgmx").emdataview(opt);
}
// 加载板块持股历史
function load_cgmxTable() {
    $.ajax({
        url: wconfig.getWebPath('datacenter') + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            reportName: 'RPT_MUTUAL_BOARD_HOLDRANKDATE',
            columns: 'TRADE_DATE',
            source: "WEB",
            client: "WEB",
            sortColumns: "TRADE_DATE",
            pageNumber: 1,
            pageSize: 20,
            sortTypes: -1,
            filter: ''
        }
    }).then(function (json) {
        var _a;
        $("#jgph_Date").show();
        var list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
        var html = [];
        list.map(function (item) {
            var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
            html.push("<option value=\"" + date + "\" \">" + date + "</option>");
        });
        $("#filter_bkmx_date").html(html.join(""));
        // 获取数据
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_NORTH_BOARD_HOLDDETAIL_NEW',
                    columns: 'ALL',
                    quoteColumns: '',
                    pageSize: 50,
                    source: "WEB",
                    client: "WEB",
                    filter: "(BOARD_CODE=\"" + bkcode + "\")",
                }
            },
            sortname: 'HOLD_MARKET_CAP',
            sortorder: 'desc',
            pagination: true,
            columns: {
                SECURITY_CODE: {
                    formatter: function (value, item, i, field) {
                        return "<a href=\"//quote.eastmoney.com/unify/r/" + fieldtools_1["default"].datatoquotecode(value) + "\">" + value + "</a>";
                    }
                },
                SECURITY_NAME_ABBR: {
                    formatter: function (value, item, i, field) {
                        return "<a href=\"/stockdata/" + item.SECURITY_CODE + ".html\">" + value + "</a>";
                    }
                },
                HOLD_DATE: {
                    formatter: function (value, item, i, field) {
                        return fieldtools_1["default"].dateformat(value);
                    }
                },
                xg: {
                    formatter: function (value, item, i, field) {
                        return '<a href="/hsgtV2/StockHdDetail/' + item.SECURITY_CODE + '.html" class="red">详细</a> <a href="//guba.eastmoney.com/list,' + item.SECURITY_CODE + '.html">股吧</a>';
                    }
                },
                xg_jgph: {
                    formatter: function (value, item, i, field) {
                        var date = fieldtools_1["default"].dateformat(item.TRADE_DATE);
                        var url = "/hsgtcg/InstitutionHdDetail/" + item.PARTICIPANT_CODE + "/" + date + ".html";
                        return '<a class="red" href="' + url + '">详细</a>';
                    }
                },
                CHANGE_RATE: {
                    formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
                },
                HOLD_SHARES: {
                    formatter: { num: 2 }
                },
                HOLD_SHARES_LAST: {
                    formatter: { num: 2 }
                },
                HOLD_SHARES_RATIO: {
                    formatter: { omit: false, num: 2, showcolor: true, fix: '%' }
                },
                HOLD_MARKET_CAP: {
                    formatter: { num: 2 }
                },
                FREE_SHARES_RATIO: {
                    formatter: { omit: false, num: 2, showcolor: false, fix: '%' }
                },
                TOTAL_SHARES_RATIO: {
                    formatter: { omit: false, num: 2, showcolor: false, fix: '%' }
                }
            },
            formatter: { strfmt: true },
            filteroptions: [
                {
                    name: "filter",
                    fieldname: "date",
                    filterselector: "#filter_bkmx_date",
                    filtersoptionselector: "option",
                    value: String($('#filter_bkmx_date').val()),
                    values: function (value) {
                        return "(HOLD_DATE='" + value + "')";
                    }
                }
            ]
        };
        $('#dataview_bkcgls').emdataview(opt);
    });
}
$("#table_type li").on("click", function () {
    $("#table_type li").removeClass("at");
    $(this).addClass("at");
    var val = $(this).data("value");
    if (val == "cgls") {
        $("#bkmx_Date").show();
    }
    else {
        $("#bkmx_Date").hide();
    }
    $("#cgmx_box,#cgls_box").hide();
    $("#" + val + "_box").show();
});
function init() {
    tophqtable();
    setInterval(tophqtable, 60000);
    load_jgcgTable();
    load_cgmxTable();
    draw_jg_cgtj();
    $('input[type=radio][name=jgmx_chart]').on("change", function () {
        var typeRadio = $('input[name="jgmx_chart"]:checked').data("type");
        console.log(typeRadio);
        draw_jg_cgtj(typeRadio);
    });
}
init();
